import { render, staticRenderFns } from "./ServiceHealth.vue?vue&type=template&id=1efd7c02"
import script from "./ServiceHealth.vue?vue&type=script&lang=js"
export * from "./ServiceHealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports